import React from "react";

const MIVTable = ({ reportData, totalcount, handlePrint, data }) => {
    console.log("reportData",reportData)
  // Extract document data once to avoid multiple optional chaining calls
  const { mivNo = "N/A", store = "N/A", createdAt = "", status = "N/A", user = "N/A", updatedAt = "" } = data?.document || {};
  const formattedCreatedAt = createdAt ? createdAt.split("T")[0] : "N/A";
  const formattedUpdatedAt = updatedAt ? updatedAt.split("T")[0] : "N/A";

  return (
    <div className="filter cm-content-box box-primary">
      <div className="content-title d-flex justify-content-between align-items-center">
        <div className="cpa">
          <i className="fa fa-list me-2"></i>MIV Items
          <span className="badge bg-orange ms-2">{totalcount}</span>
        </div>
        <div className="d-flex align-items-center">
          {reportData.length > 0 && (
            <button className="btn btn-primary me-3" onClick={handlePrint}>
              Print
            </button>
          )}
        </div>
      </div>
      <div className="cm-content-body form excerpt">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>MIV No</th>
                  <th>Store</th>
                  <th>Date</th>
                  <th>Part No</th>
                  <th>Description</th>
                  <th>Unit</th>
                  <th>Approved Qty</th>
                  <th>Used Qty</th>
                  <th>Status</th>
                  <th>Store Keeper</th>
                  <th>Updated Date</th>
                </tr>
              </thead>
              <tbody>
                {reportData.length > 0 ? (
                  reportData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{mivNo}</td>
                      <td>{store}</td>
                      <td>{formattedCreatedAt}</td>
                      <td>{item?.partNo || "N/A"}</td>
                      <td className="scrollable-description">{item?.description || "N/A"}</td>
                      <td>{item?.unitName || "N/A"}</td>
                      <td>{item?.approveQty || "N/A"}</td>
                      <td>{item?.usedQty || "N/A"}</td>
                      <td>{status}</td>
                      <td>{user}</td>
                      <td>{formattedUpdatedAt}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12" className="text-center">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MIVTable);
